// extracted by mini-css-extract-plugin
module.exports =  {"popover":"Lq7ZY9umg_TbfrH3eC2E","header":"VxdaAYk9dg1Mw7qCgsGA","body":"S7ta_AyVx2vthep4YYv7","actions":"usqkjch6clxciwEysLQo"};